import { Chip, styled } from "@mui/material"

export const PillsInfo = styled(Chip)({})

PillsInfo.defaultProps = {
  variant: "outlined",
  size: "large",
}
